<script>
	import { onMount, onDestroy } from "svelte";
	import { Button, Col, Row } from "@sveltestrap/sveltestrap";
	import client from "../../../services/client";
	import {
		errorMessage,
		sizeSelect,
		totalPages,
		loading,
		initPage,
		canvasOpen,
		evLogIds,
	} from "../../../store/store";
	import EvManagementTable from "./EvManagementTable.svelte";
	import ErrorMessageHandler from "../../../components/ErrorMessageHandler/ErrorMessageHandler.svelte";
	import PageHeader from "../../../components/PageHeader/PageHeader.svelte";
	import FilterForm from "../../../components/FilterForm/FilterForm.svelte";
	import LimitSize from "../../../components/SizeSelect/SizeSelect.svelte";
	import CustomOffCanvas from "../../../components/CustomOffCanvas/CustomOffCanvas.svelte";
	import { extractErrorMessage } from "../../../utils/misc";
	import Modal from "./ModalEvLogs.svelte";

	let data = [];

	//Start Logic for filter feature
	const params = new Proxy(new URLSearchParams(window.location.search), {
		get: (searchParams, prop) => searchParams.get(prop),
	});
	$: queryParams = `?page=1&size=${$sizeSelect}`;
	let searchParams = window.location.search.toString();
	let querySize = searchParams.includes("size");
	let queryPage = searchParams.includes("page");
	let queryStationId = searchParams.includes("stationId");
	let queryAddress = searchParams.includes("addressQuery");

	$: if (queryPage) {
		queryParams = `?page=${params.page}&size=${$sizeSelect}`;
	}
	$: if (queryPage && querySize) {
		queryParams = `?page=${params.page}&size=${$sizeSelect}`;
	}
	$: if (queryStationId) {
		queryParams = queryParams.concat(`&stationId=${params.stationId}`);
	}
	$: if (queryAddress) {
		queryParams = queryParams.concat(`&keyword=${params.addressQuery}`);
	}
	//End Logic for filter feature

	//FETCH EV Charging Lot LIST
	onMount(async () => {
		fetchEvChargingLot();
	});

	//Function to fetch charging lot list and trigger size select
	const fetchEvChargingLot = async (limi) => {
		try {
			loading.set(true);
			errorMessage.set("");
			const res = await client(`/v1/evChargingLot${queryParams}`, {
				method: "GET",
				version: "evCharging",
			});
			data = res.data.data.dataList;
			data.totalCount = res.data.data.totalCount;
			totalPages.set(res.data.data.totalPage);
			if (res.data.data.dataList) {
				loading.set(false);
			}
		} catch (err) {
			loading.set(false);
			extractErrorMessage(err);
			console.log(err);
		}
	};

	let err;
	errorMessage.subscribe((value) => {
		err = value;
	});

	let canvasData;
	let load;
	let loadUpdate;
	export const handleExportCSV = async () => {
		canvasData = "CSV export in progress";
		canvasOpen.set(true);
		load = true;
		try {
			const res = await client("/v1/evChargingLot/export", {
				method: "POST",
				version: "evCharging",
			});
			const url = window.URL.createObjectURL(new Blob([res.data]));
			const link = document.createElement("a");
			link.href = url;
			link.setAttribute("download", "EvManagementLotList.csv"); //or any other extension
			document.body.appendChild(link);
			link.click();

			load = false;
			canvasData = "CSV export is successfull";
		} catch (err) {
			load = false;
			extractErrorMessage(err);
			console.log(err);
		}
	};

	let modalOpen = false;
	export const handleListUpdate = async () => {
		loadUpdate = true;
		try {
			const res = await client("/v1/evChargingLot/updateList", {
				method: "POST",
				version: "evCharging",
			});

			if (res.data.data.evLogIds) {
				evLogIds.set(res.data.data.evLogIds);
				canvasData = ` Update for log ids: ${res.data.data.evLogIds.toString()} has started`;
			} else {
				canvasData = "No updates";
			}

			canvasOpen.set(true);
			loadUpdate = false;
		} catch (err) {
			loadUpdate = false;
			extractErrorMessage(err);
			console.log(err);
		}
	};

	function toggleModalUpdate() {
		modalOpen = false;
		modalOpen = true;
	}

	onDestroy(() => {
		initPage.set(1);
		sizeSelect.set("20");
	});
</script>

<Row>
	<Col xs={12}>
		<div>
			<ErrorMessageHandler message={err} />
			<Col className="row d-flex align-items-start mx-0">
				<PageHeader title="EV Charging Lot Management" />
			</Col>
			<CustomOffCanvas messages={canvasData} />
			<div class="d-flex flex-row">
				<Col xs={6}>
					<FilterForm addressQuery stationId />
				</Col>
				<Col class="d-flex justify-content-end" xs={6}>
					<div>
						{#if !load}
							<div class="mx-2">
								<Button
									class="themeButton primary px-4 "
									type="button"
									on:click={() => handleExportCSV()}
								>
									Export CSV
								</Button>
							</div>
						{:else if load}
							<div class="">
								<Button
									class="themeButton primary px-4"
									type="button"
									disabled
								>
									<output
										class="spinner-grow spinner-grow-sm"
										aria-hidden="true"
									/>
									Loading...
								</Button>
							</div>
						{/if}
						<div class="my-2 mx-2">
							<LimitSize trigerSelect={fetchEvChargingLot} />
						</div>
					</div>
				</Col>
			</div>
			<div />
		</div>
	</Col>
	<Col class="my-2">
		<EvManagementTable {data} />
	</Col>
</Row>
{#if !!modalOpen}
	<Modal showModal={!!modalOpen} />
{/if}

<style>
	:global(.link.svelte-gokig2) {
		color: #011851 !important;
		text-decoration: none !important;
		cursor: pointer;
	}
</style>
